'use strict';
/**
 * @name uomDetailsCtrl
 * @desc Controller for master data UOM details controller
 */
function uomDetailsCtrl($scope, $uibModalInstance, uomDetails, singleUom, toastr, globalFunc) {
  $scope.editClicked = false;
  $scope.uomDetails = uomDetails.data;
  $scope.originalCode = $scope.uomDetails.code;

  // Statuses for dropdown in object
  $scope.uomStatuses = [
    { isActive: 'Active' },
    { isActive: 'Deactivated' }
  ];

  $scope.uomFraction = [
    {
      status: 'Allow',
      value: 1
    },
    {
      status: 'Disallow',
      value: 0
    }
  ];

  $scope.tab = 1;
  $scope.historyDependencies = {
    embeddedParams: {
      'object[0][object_id]': $scope.uomDetails._id,
      'object[0][object_type]': 'Metabuyer\\Models\\UOM',
      offset: 5,
      order_by: '-created_at' // Created at, descending
    }
  };

  $scope.toggleTab        = toggleTab;
  $scope.cancel           = cancel;
  $scope.editUOM          = editUOM;
  $scope.updateUom        = updateUom;
  $scope.duplicationCheck = duplicationCheck;

  function toggleTab(tab) {
    return $scope.tab = tab;
  }

  function setFraction(uom){
    if(uom.is_fraction ===1){
      uom.is_fraction = {
        status: 'Allow',
        value: 1
      };
    }else{
      uom.is_fraction = {
        status: 'Disallow',
        value: 0
      };
    }
  }


  function cancel() {
    $uibModalInstance.close();
  }

  function editUOM(){
    $scope.editClicked = true;
  }

  function validate(uom){
    if (!uom){
      return false;
    }
    if (!uom.code){
      return false;
    }
    if (!uom.descr){
      return false;
    }
    if (!uom.uomStatus){
      return false;
    }
    if (!uom.is_fraction){
      return false;
    }
    return true;
  }

  function updateUom() {
    if(!!$scope.codeCheck){
      toastr.error($scope.uomDetails.code + ' is already in use');
    }
    else if(validate($scope.uomDetails)){
      swal({
          title: 'Confirm Updating the UOM',
          text: 'This will update the details for this UOM',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#1ab394  ',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          closeOnConfirm: true,
          closeOnCancel: true
        },
        function (confirmed) {
          if (!!confirmed) {
            // set status in integer to pass it as parameter
            var tempStatus;
            switch($scope.uomDetails.uomStatus.isActive.toLowerCase()){
              case 'active':
                tempStatus = 1;
                break;
              case 'deactivated':
                tempStatus = 0;
                break;
              case 'disabled':
                tempStatus = 3;
                break;
            }

            $scope.uomDetails.is_active = $scope.uomDetails.uomStatus.isActive.toUpperCase();
            $scope.uomDetails.updated_at = new Date();

            singleUom.put(
              {
                id: $scope.uomDetails._id
              },
              {
                code: $scope.uomDetails.code,
                descr: $scope.uomDetails.descr,
                is_active: tempStatus,
                is_fraction: !!$scope.uomDetails.is_fraction ? $scope.uomDetails.is_fraction.value : 0
              },
              function (resource) {
                toastr.success('UOM has been updated');
                $uibModalInstance.close(resource.content.data);
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
                return false;
              }
            );
          } else {
            return false;
          }
        }
      );
    }
  }

  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'codeCheckTrue':
          if($scope.uomDetails.code != $scope.originalCode){
            $scope.codeCheck = true;
          }
          else{
            $scope.codeCheck = false;
          }
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }


  function initialize() {
    if(!!$scope.uomDetails.is_active) {
      $scope.uomDetails.uomStatus = {isActive: globalFunc.capitalizeFirstCharacter($scope.uomDetails.is_active)};
    }

    setFraction($scope.uomDetails);
  }

  initialize();
}

uomDetailsCtrl.$inject = [
  '$scope', '$uibModalInstance', 'uomDetails', 'singleUom', 'toastr', 'globalFunc'
];

angular
  .module('metabuyer')
  .controller('uomDetailsCtrl', uomDetailsCtrl);
